export default __webpack_public_path__ + "static/media/video-1.74ab575f.mov";